import TimesOneMobiledata from "@mui/icons-material/TimesOneMobiledata";
import LoopIcon from "@mui/icons-material/Loop";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { BillingModelEnums } from "src/api/types";
import { capitalize } from "src/utils/capitalize";

interface Props1 {
  model: BillingModelEnums;
  size?: "small" | "inherit" | "large" | "medium";
}
const BillingModel = ({ model, size = "large" }: Props1) => {
  return (
    <Tooltip
      arrow
      title={<Typography>{capitalize(model.split("_").join(" "))}</Typography>}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        },
      }}
    >
      {model === "one_time" ? (
        <TimesOneMobiledata color="secondary" fontSize={size} />
      ) : (
        <LoopIcon color="secondary" fontSize={size} />
      )}
    </Tooltip>
  );
};

export default BillingModel;
